<template>
  <div class="mapouter">
    <div class="gmap_canvas">
      <iframe id="gmap_canvas"
              width="100%"
              height="100%"
              src="https://maps.google.com/maps?q=Techno%20club%20HALL&t=&z=15&ie=UTF8&iwloc=&output=embed"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0">
      </iframe>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Location"
  }
</script>

<style scoped>
  .mapouter {
    position: relative;
    text-align: right;
    height: 550px;
    width: 100%;
  }

  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 550px;
    width: 100%;
    filter: grayscale(50%);
  }

</style>